const faqs = [
  {
    q: '爱丫爱丫影院真的免费吗？需要注册吗？',
    a: '是的，本站所有电影完全免费在线观看，无需注册、无需登录，打开浏览器即可直接播放，真正做到即点即看。',
  },
  {
    q: '视频画质怎么样？会卡顿吗？',
    a: '全站影片支持 1080P 高清画质播放，采用先进的视频分发技术，正常情况下可以做到秒开不缓冲。播放流畅度取决于您的网络环境，建议使用 Wi-Fi 或 4G/5G 网络以获得最佳体验。',
  },
  {
    q: '可以在手机上看吗？',
    a: '完全可以！爱丫爱丫影院已全面适配手机和平板设备，打开手机浏览器访问我们的网站即可享受与桌面端一致的观影体验，片源同步更新，进度云端同步。',
  },
  {
    q: '片源多久更新一次？有最新的电影吗？',
    a: '我们的内容团队每日更新片源，涵盖最新上映的动作电影、喜剧电影、经典修复版等多种类型。热门新片会第一时间上线，同时经典影片也会持续补充修复版本，确保您总有新片可看。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">
            常见问题
          </h2>
          <p className="mt-3 text-sm text-foreground-600 max-w-xl mx-auto">
            关于观影体验的常见疑问，这里有答案
          </p>
        </div>

        <div className="max-w-2xl mx-auto space-y-3 md:space-y-4">
          {faqs.map((faq) => (
            <details
              key={faq.q}
              className="group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden"
            >
              <summary className="flex items-center justify-between p-5 md:p-6 cursor-pointer list-none">
                <h3 className="text-sm md:text-base font-semibold text-foreground-950 pr-4">
                  {faq.q}
                </h3>
                <span className="w-5 h-5 flex-shrink-0 flex items-center justify-center text-foreground-400 group-open:hidden">
                  <i className="ri-add-line"></i>
                </span>
                <span className="w-5 h-5 flex-shrink-0 hidden group-open:flex items-center justify-center text-foreground-400">
                  <i className="ri-subtract-line"></i>
                </span>
              </summary>
              <div className="px-5 md:px-6 pb-5 md:pb-6">
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                  {faq.a}
                </p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}